import React, { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: transparent;
  align-items: center;
  justify-content: center;
`;

const UpMessage = styled.h1`
  margin-bottom: 0;
  font-weight: 500;
  letter-spacing: 0.2em;
`;

const Separator = styled.div`
  max-width: 33em;
  width: 100%;
  height: 1px;
  background-color: ${p => p.theme.colors.red};
  margin: 2em 0;
`;

const DownMessage = styled.p`
  font-size: 1.5em;
  font-weight: 600;
`;

const copy = {
  up: `Hvala Vam`,
  down: `Javićemo Vam se uskoro.`,
};

export const ThankYouMessage: FC = () => (
  <Wrapper>
    <UpMessage>{copy.up}</UpMessage>
    <Separator />
    <DownMessage>{copy.down}</DownMessage>
  </Wrapper>
);
